// de strings for messages/upsell.ts. Same keys and {variables} as en there.
import type { Dict } from "../index";

const upsell: Dict = {
  "upsell.creator.train.title": "Mit Creator trainieren",
  "upsell.creator.train.lead": "Stimmen trainieren ist bei Creator dabei.",
  "upsell.creator.train.tick1": "Unbegrenzt Stimmen trainieren",
  "upsell.creator.train.tick2": "Marble-Run-Videos, 50 Coins pro Monat",
  "upsell.creator.train.tick3": "Alles aus deinem Plan bleibt",
  "upsell.creator.train.cta": "Upgraden und trainieren",

  "upsell.creator.export.title": "Export in 1080p",
  "upsell.creator.export.lead":
    "Mit Creator exportierst du deine Videos in vollem 1080p.",
  "upsell.creator.export.tick1": "Exporte in 1080p",
  "upsell.creator.export.tick2": "Marble-Run-Videos, 50 Coins pro Monat",
  "upsell.creator.export.tick3": "Unbegrenzt Stimmen trainieren",
  "upsell.creator.export.cta": "Upgraden und in 1080p exportieren",

  "upsell.creator.marble.title": "Marble Run gibt's mit Creator",
  "upsell.creator.marble.lead":
    "Mach aus Covern Marble-Run-Videos, fertig für TikTok und Reels.",
  "upsell.creator.marble.tick1": "50 Marble-Run-Coins jeden Monat",
  "upsell.creator.marble.tick2": "Studio-Exporte in 1080p",
  "upsell.creator.marble.tick3": "Unbegrenzt Stimmen trainieren",
  "upsell.creator.marble.cta": "Upgraden und Marble Run erstellen",

  "upsell.creator.video.title": "Videos gibt's mit Creator",
  "upsell.creator.video.lead":
    "Mach aus deinen Covern teilbare Videos für TikTok und Reels.",
  "upsell.creator.video.tick1": "Teilbare Videos, 50 Coins pro Monat",
  "upsell.creator.video.tick2": "Studio-Exporte in 1080p",
  "upsell.creator.video.tick3": "Unbegrenzt Stimmen trainieren",
  "upsell.creator.video.cta": "Upgraden und Video erstellen",

  "upsell.creator.samplesOne":
    "Deine Aufnahmen sind bereit: {files} Datei, {duration}. ",
  "upsell.creator.samplesMany":
    "Deine Aufnahmen sind bereit: {files} Dateien, {duration}. ",
  "upsell.creator.nothing": "Nichts",
  "upsell.creator.today": "heute",
  "upsell.creator.toPayToday": "heute zu zahlen",
  "upsell.creator.thenMonth": "danach {price} pro Monat",
  "upsell.creator.credited":
    "Der Rest deines aktuellen Monats wird angerechnet. Jederzeit kündbar.",
  "upsell.creator.priceError":
    "Wir konnten deinen Upgrade-Preis nicht laden. Du kannst jederzeit in den Einstellungen upgraden.",
  "upsell.creator.upgrading": "Wird upgegradet...",
  "upsell.creator.notNow": "Nicht jetzt",
  "upsell.creator.payFailed":
    "Die Zahlung ist nicht durchgegangen, es hat sich also nichts geändert. Prüf deine Karte in den Einstellungen und versuch es erneut.",

  "upsell.coins.title": "Pro Coins holen",
  "upsell.coins.subtitle": "Jeder Coin erstellt ein teilbares Video",
  "upsell.coins.coinAlt": "Pro Coin",
  "upsell.coins.useMarble": "Marble-Run-Videos",
  "upsell.coins.useLyric": "Lyric-Videos",
  "upsell.coins.useTemplates": "Alle Videovorlagen",
  "upsell.coins.bestValue": "BESTER PREIS",
  "upsell.coins.mostCoins": "MEISTE COINS",
  "upsell.coins.proCoins": "Pro Coins",
  "upsell.coins.each": "{price}/Stück",
  "upsell.coins.purchase": "Kaufen",
  "upsell.coins.footer":
    "Pro Coins werden sofort gutgeschrieben und verfallen nie. 1 Coin = 1 Video.",
};

export default upsell;
